/**
 * R-261/R-262 — statuses that mark a document VOIDED: the row remains as the
 * record but the doc is no longer work. "split" = 5c-2 container parent,
 * "merged" = 5d-4b/5d-5b absorbed source, "deleted" = 5d-5a operator delete.
 * Moved to shared in 5d-5b so the worker's release sweep sees the same list.
 */
export const VOIDED_DOC_STATUSES = ["split", "merged", "deleted"];
//# sourceMappingURL=voided-statuses.js.map